import Head from 'next/head'
import Script from 'next/script'
import React from 'react'
import { getPublicLayout } from '@public/components/PublicLayout'
import { Flex } from 'components/Layout'
import { SPACE } from 'Theme'
import { prepareGetStaticNavigationProps } from '../utils/prepareGetStaticNavigationProps'

export const GiveawayLuluandgeorgiaSss = () => (
  <>
    <Head>
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="" />
      <meta
        name="twitter:description"
        content="Two entrants will have the chance to win a $500 Lulu & Georgia gift card and a 25 min. consultation with Sarah Sherman Samuel via The Expert. Enter your information for a chance to win."
      />
      <meta
        name="twitter:image"
        content="https://res.cloudinary.com/viralsweep/image/upload/v1646095418/vpcxkewcchczmbqyvvgg.jpg"
      />

      <meta
        property="og:url"
        content="theexpert.com/giveaway-luluandgeorgia-sss"
      />
      <meta property="og:type" content="article" />
      <meta property="og:title" content="" />
      <meta
        property="og:image"
        content="https://res.cloudinary.com/viralsweep/image/upload/v1646095418/vpcxkewcchczmbqyvvgg.jpg"
      />
      <meta property="og:site_name" content="" />
      <meta property="fb:admins" content="1088490351" />
      <meta property="fb:admins" content="11512735" />
      <meta property="fb:admins" content="1088490312" />
      <meta
        property="og:description"
        content="Two entrants will have the chance to win a $500 Lulu & Georgia gift card and a 25 min. consultation with Sarah Sherman Samuel via The Expert. Enter your information for a chance to win."
      />
    </Head>
    <Flex width="100%" height="100%" justifyContent="center" my={SPACE.PX_15}>
      <div id="vsscript_106740_167365" />
      <Script
        async
        type="text/javascript"
        src="https://app.viralsweep.com/vsa-widget-1772a1-106740.js?sid=106740_167365"
      />
    </Flex>
  </>
)

export function getStaticProps() {
  return prepareGetStaticNavigationProps()
}

GiveawayLuluandgeorgiaSss.getLayout = getPublicLayout
